import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const CaretDownIcon = forwardRef(({ title = 'Caret Down Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 12 9" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "m.65 2.34 5 5.31c.2.2.5.2.7 0l5-5.3c.2-.21.2-.55 0-.76l-.7-.75a.5.5 0 0 0-.71 0L6 5.02 2.06.84a.5.5 0 0 0-.7 0l-.71.75c-.2.21-.2.55 0 .75" })));
});
//# sourceMappingURL=caret_down_icon.js.map